import { PUPTIMUS_PRIMIE_CUSTOMER_ID } from '@/config/constants';
import { Customer } from '@/types/Customer';

export const isPuptimusPrime = (customer: Customer) => {
  return customer.customerID === PUPTIMUS_PRIMIE_CUSTOMER_ID;
};
